import React from "react";
import { object, string } from "prop-types";

import ProfileMenuItem from "../ProfileMenuItem";

import "./profile-menu.m.css";

const ProfileMenu = ({ type = "profile", member }) => (
  <div styleName="wrapper" className="profile-menu">
    <ProfileMenuItem label="My Account" type="outer" />
    <ProfileMenuItem label="My Profile" isActive={type === "profile"} href="/profile" />
    <ProfileMenuItem label="Edit Profile" href="/profile/edit" isActive={type === "edit-profile"} />
    {member && !member["verification-status"].includes("social-") && (
      <ProfileMenuItem href="/profile/change-password" label="Change Password" isActive={type === "change-password"} />
    )}
    <ProfileMenuItem label="Activities" type="outer" />
    <ProfileMenuItem label="My Comments" href="/my-comments" isActive={type === "comments"} />
    <ProfileMenuItem label="Saved Articles" isActive={type === "saved_news"} href="/saved" type="saved_news" />
  </div>
);
ProfileMenu.propTypes = {
  type: string,
  member: object,
};

export default ProfileMenu;
